/* eslint @typescript-eslint/no-explicit-any: 0 */ // TODO (скорее всего не получится сделать такой функционал без использования any, из-за путаницы с аргументами в хендлере)
import { Event } from '@yandex-int/messenger.utils';
import { EventChannel } from 'redux-saga';
import { ForkEffect } from 'redux-saga/effects';
import { SagaGenerator, take, takeEvery, takeLatest } from 'typed-redux-saga';

import { NotUndefined } from '../../types';
import { emitterEventChannelFactory } from './emitterEventChannelFactory';
import { EventEmitter } from './event-emitter';
import { eventChannelFactory } from './eventChannelFactory';

export class ChannelHolder {
    private mapEventToChannel = new Map<Event<any>, EventChannel<any>>();
    private mapEmitterToChannel = new Map<EventEmitter, Map<string, EventChannel<any>>>();

    public *take<T extends NotUndefined>(event: Event<T>) {
        return yield* take(this.getChannelForEvent(event));
    }

    public takeLatest<T>(
        emitter: EventEmitter,
        event: string,
        handler: (...args: [T]) => any
    ): SagaGenerator<never, ForkEffect<T>>;
    public takeLatest<T>(emitter: Event<T>, handler: (item: T) => any): SagaGenerator<never, ForkEffect<T>>;
    public takeLatest<T extends NotUndefined>(
        emitter: EventEmitter | Event<T>,
        handlerOrEventName: string | ((item: T) => any),
        handler?: (...item: [T]) => any
    ) {
        return this.takeEffect(takeLatest, emitter, handlerOrEventName, handler);
    }

    public takeEvery<T>(
        emitter: EventEmitter,
        event: string,
        handler: (...args: [T]) => any
    ): SagaGenerator<never, ForkEffect<T>>;
    public takeEvery<T extends NotUndefined>(
        emitter: Event<T>,
        handler: (item: T) => any
    ): SagaGenerator<never, ForkEffect<T>>;
    public takeEvery<T extends NotUndefined>(
        emitter: EventEmitter | Event<T>,
        handlerOrEventName: string | ((item: T) => any),
        handler?: (...item: [T]) => any
    ) {
        return this.takeEffect(takeEvery, emitter, handlerOrEventName, handler);
    }

    private *takeEffect<T extends NotUndefined>(
        effect: typeof takeEvery,
        emitter: EventEmitter | Event<T>,
        handlerOrEventName: string | ((item: T) => any),
        handler?: (...args: any[]) => any
    ) {
        if (emitter instanceof Event && typeof handlerOrEventName === 'function') {
            return yield* effect(this.getChannelForEvent(emitter), handlerOrEventName);
        }

        if (emitter instanceof EventEmitter && typeof handlerOrEventName === 'string' && handler) {
            return yield* effect(this.getChannelForEmmiter(emitter, handlerOrEventName), handler);
        }

        throw new Error('unsupported format');
    }

    public close() {
        this.mapEventToChannel.forEach((channel) => {
            channel.close();
        });

        this.mapEventToChannel.clear();

        this.mapEmitterToChannel.forEach((item) => {
            item.forEach((channel) => {
                channel.close();
            });

            item.clear();
        });

        this.mapEmitterToChannel.clear();
    }

    public getChannelForEvent<T extends NotUndefined>(event: Event<T>): EventChannel<T> {
        const channel = this.mapEventToChannel.get(event);

        if (channel) {
            return channel;
        }

        const newChannel = eventChannelFactory(event);

        this.mapEventToChannel.set(event, newChannel);

        return newChannel;
    }

    public getChannelForEmmiter<T>(emitter: EventEmitter, name: string): EventChannel<[T]> {
        const holder = this.mapEmitterToChannel.get(emitter);
        const channel = holder?.get(name);

        if (channel) {
            return channel;
        }

        const newChannel = emitterEventChannelFactory<[T]>(emitter, name);

        if (!holder) {
            this.mapEmitterToChannel.set(emitter, new Map([[name, newChannel]]));
        } else {
            holder.set(name, newChannel);
        }

        return newChannel;
    }
}
